import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { callAPI, IsSmallScreen, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import http from "../../../commonFunctions/httpClient";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from '../../../commonFunctions/PermissionManger';
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../../Components/DataGrid/WSMobileDataGridAdvanced";
import { openPopUp } from "../../../Components/Dialog/OpenNewModal";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../../StateManagement/actions";
import { UpdateStatus } from "./UpdateStatus";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";

export const LeadList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getLeadPermission;
  const [leadListData, setLeadlistData] = useState<any>([])
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();
  const isMobile = IsSmallScreen();
  const [rowId, setRowId] = useState<any>(null);
  const location = useLocation();
  const { status } = location.state || {};

  const {
    open,
    title,
    onConfirm,
    handleClose,
    openConfirmDialog,
  } = useConfirmDialog();
  useEffect(() => {
    updateMainHeader('Leads');

    breadCrumbsStore.updateBreadCrumbs([
      { "Leads": "" },


    ]);
  });


  const source = {
    url: "leads/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "leadType",
        operator: "eq",
        value: "0"
      },
      ...(status ? [status] : []) // ✅ only include if status exists
    ],
    sort: [
      {
        field: "UptedAt", // maybe typo? was "UptedAt"
        direction: "desc"
      }
    ],
  };
  const handleDelete = async (id?: string | number) => {
    const response: any = await callAPI(`leads`, Method.DELETE, null, id);
    dispatch(resetDataComponent('leadGrid'));
    if (response?.success) {
      showMessage(response?.message, "success")
    }
    else {
      showMessage(response?.message || 'Something went wrong', "error")
    }
    handleClose()

  };

  /**
   * Edit function
   * @param action 
   * @param row 
   */
  const handleAction = async (action: string, row: any) => {

    if (action === "View") {
      navigate(`/leads/edit/${row?.id}`)
    }
    else if (action === "Delete") {
      openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
    }
    else if (action === "Convert to Contact") {
      const response = await convertToLead(row?.id)
      if (response?.message) {
        dispatch(resetDataComponent("leadGrid"));
        showMessage('Lead is converted to Contact successfully!', "success")
        const data: any = leadListData.filter((item: any) => item.leadType === 0);
        setLeadlistData(data);
      }
      else {
        showMessage(response?.message || 'Something went wrong', "error")
      }
    }
    else if (action === 'Site Visit') {
      await handleStatus(row);
      await submitSiteVisitNotifications(row);
    }
    else if (action === "Change Status") {
      const metadataStatus: IMetaData = {
        title: "Update Status",
        hideActions: false,
        content: (props: any, rows: any) => <UpdateStatus {...props} contact={true} rowId={row?.id} />,
        actions: [
          {
            label: "Cancel",
            className: "ws-cancel",
            type: "button"
          },
          {
            label: "Submit",
            onClick: handleStatusChange,
            type: "submit",
            autoFocus: true
          }
        ],
        isDragable: true
      };
      openPopUp(metadataStatus, handleStatus, "40rem");
    }
  };
  const handleStatusChange = async (data: any) => {
    try {
      // setLoading(true);
      const response: any = await saveData(data);
      if (response && response.message) {
        dispatch(resetDataComponent("contactGrid"));
        showMessage(
          response.message || "Status updated successfully!",
          "success"
        );
      }
    } catch (e: any) {
      showMessage(e.error, "error");
    }
  };
  const submitSiteVisitNotifications = async (row: any) => {
    try {

      const response: any = await http.post(`leads/notify/pincode/${row.zipCode}`, {});
      if (response) {
        showMessage(response?.message, response?.success ? 'success' : 'error')
      }

    } catch (error) {

    }

  }
  const convertToLead = async (id: string) => {
    const response: any = await callAPI(`leads`, Method.PUT, { LeadType: 1 }, id);
    if (response) {
      return response
    }
    return false
  }

  const columns: IColumns[] = [
    {
      header: "Company",
      fieldName: "company",
      type: "default",
    },
    {
      header: "Full Name",
      fieldName: "fullName",
      type: "default",
      //  sortable: true
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      type: "default",
    },
    {
      header: "Mobile",
      fieldName: "mobile",
      tooltip: true,
      isHide: isMobile,
      type: "default",
    },
    {
      header: "status",
      fieldName: "status",
      tooltip: true,
      type: "status"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "View" : undefined, "Convert to Contact", "Site Visit", "Change Status", remove ? "Delete" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
      fieldCompare: { fieldName: 'leadType', ValueCheck: { value: 1, actionCheck: "Convert to Contact" } }

    },

  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Full Name",
      fieldName: "fullName",
      labelSx: { fontWeight: 'bold' },
      type: "default",
      sm: 6,
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      type: "default",
      sm: 6
    },
    {
      header: "Company",
      fieldName: "company",
      type: "default",
      sm: 6
    },

    {
      header: "Mobile",
      fieldName: "mobile",
      tooltip: true,
      sm: 6,
      type: "default",
    },

    {
      header: "status",
      fieldName: "status",
      tooltip: true,
      sm: 6,
      type: "default"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      sm: 4,
      actions: ["Edit", "Convert to Contact", "Site Visit"],
      actionCallback: (action, row) => handleAction(action, row),

    },

  ];
  useEffect(() => {
    if (rowId) {
      openPopUp(metadataStatus, handleStatus, "40rem", handleCloseDialog);
    }
  }, [rowId]);
  const handleClick = () => {
    navigate('/leads/create')
  }
  const handleCloseDialog = (data?: any) => {
    setRowId(null);
  };
  const handleStatus = async (row: any) => {
    try {
      const response: any = await saveData(row);
      setRowId(null);
      if (response && response.message) {
        dispatch(resetDataComponent("leadGrid"));
        showMessage(
          response.message || "Status updated successfully!",
          "success"
        );
      }
    } catch (e: any) {
      showMessage(e.error, "error");
    } finally {
      setRowId(null);
    }
  };
  const saveData = async (data: any) => {
    const request: any = {
      leadId: data?.id,
      status: 'Site Visit',
      statusDetails: "Status Updated"
    };

    const response: any = await callAPI(`lead-status`, Method.PUT, request, data?.id);

    return response;
  };
  const metadataStatus: IMetaData = {
    title: "Update Status",
    hideActions: false,
    content: (props: any, row: any) => <UpdateStatus {...props} contact={true} />,
    actions: [
      {
        label: "Cancel",
        className: "ws-cancel",
        type: "button"
      },
      {
        label: "Submit",
        onClick: handleStatus,
        type: "submit",
        autoFocus: true
      }
    ],
    isDragable: true
  };
  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any) => {
        item.fullName = `${item?.firstName} ${item?.lastName ? item?.lastName : ''}`;
      })
      return data
    }
  }
  return (
    <>
      {/* <RazorpayCheckout /> */}
      <Grid container spacing={2}>
        {view ?
          <Grid item xs={12}>
            {!isMobile && <WSDataGrid
              id="leadGrid"
              title="Leads"
              columns={columns}
              source={source}
              transFormData={transFormData}
              addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}
              searchBox={{ fieldName: 'firstName,company,lastName,mobile' }}
              gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
            />
            }
            {isMobile &&
              <WSMobileDataGridAdvanced transFormData={transFormData} title={'Leads'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                onAddButtonClick={handleClick} columns={mobColumns} id="leadGrid" source={source} />
            }
          </Grid>
          : <PermissionDenied />
        }
      </Grid>
      <ConfirmDialog
        open={open}
        title={title}
        onConfirm={onConfirm}
        onClose={handleClose}
      />
    </>
  )
})